module.exports = __webpack_public_path__ + "img/suowaijiuyi.34fb643a.png";